import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICreateSubRouteFunctionActivities } from './interface/create-sub-route-function-activities.interface copy';
import { SubRouteFunctionActivityService } from './sub-route-function-activities.service';
import SubRouteActivityAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route-activity/sub-route-activity.entity';
import { SubRouteActivityService } from '../sub-route-activitie/sub-route-activitie.service';
import { DocumentClassAttributes, DocumentTypeAttributes, ReasonVisitAttributes } from '@albatrosdeveloper/ave-models-package';
import { ReasonVisitService } from '../../master/reason-for-visit/reason-for-visit.service';
import { DocumentTypeService } from '../../document/document-type/document-type.service';
import { DocumentClassService } from '../../document/document-class/document-class.service';

@Component({
  selector: 'app-add-sub-route-function-modal',
  styleUrl: './sub-route-function-activities.component.scss',
  templateUrl: './sub-route-function-activities.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggle,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatCheckboxModule,
  ],
})
export class AddSubRouteFunctionActivitie {
  currentCreateActivitie: ICreateSubRouteFunctionActivities = this.initializeCreateActivitie();
  isEditMode : boolean;
  isDuplicate: boolean = false;

  activityList: SubRouteActivityAttributes[] = [];
  reasonVisitList: ReasonVisitAttributes[] = [];
  documentTypeList: DocumentTypeAttributes[] = [];
  documentClassList: DocumentClassAttributes[] = [];

 constructor(
     public dialogRef: MatDialogRef<AddSubRouteFunctionActivitie>,
     private activitieService: SubRouteFunctionActivityService,
     private subrouteActivityService: SubRouteActivityService,
     private reasonVisitService: ReasonVisitService,
     private documentTypeService: DocumentTypeService,
     private documentClassService: DocumentClassService,
     private snackBar: MatSnackBar,
     @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.isEditMode = !!data; 
        if (this.isEditMode) {
          this.currentCreateActivitie = {
            ...data,
            activityId: data.activity ? data.activity._id.toString() : null,
            defaultReasonVisitId: data.defaultReasonVisit ? data.defaultReasonVisit._id.toString() : null,
            documentTypeToCreateId: data.documentTypeToCreate ? data.documentTypeToCreate._id.toString() : null,
            documentClassToCreateId: data.documentClassToCreate ? data.documentClassToCreate._id.toString() : null,
          };          
        }
      }
      
  
  ngAfterViewInit(): void {
    this.fetchsubrouteactivity();
    this.fetchreasonVisit();
    this.fetchdocumentType();
    this.fetchdocumentClass();
  }

  private fetchdocumentType(): void {
    this.documentTypeService.findToComboBox().subscribe((res) => {
      this.documentTypeList = res.data;
    });
  }

  private fetchdocumentClass(documentTypeId? : string | string[]): void {
    const idsToFetch = Array.isArray(documentTypeId) ? documentTypeId : documentTypeId ? [documentTypeId] : [];
    this.documentClassService.findToComboBox(idsToFetch).subscribe((res) => {
      this.documentClassList = res.data;
    });
  }

  onDocumentTypeSelectionChange(documentTypeId: string): void {
    this.currentCreateActivitie.documentClassToCreateId = null;
      if(documentTypeId)
      {
        this.fetchdocumentClass(documentTypeId);
      }
  }

  private fetchsubrouteactivity(): void {
    this.subrouteActivityService.findToComboBox().subscribe((res) => {
      this.activityList = res.data;
    });
  }

  private fetchreasonVisit(): void {
    this.reasonVisitService.findToComboBox().subscribe((res) => {
      this.reasonVisitList = res.data;
    });
  }

  isActivityCodeValid(): boolean {
    const selectedActivity = this.activityList.find(
      (activity) => activity._id.toString() === this.currentCreateActivitie.activityId.toString()
    );
    
    if (selectedActivity) {
      if (selectedActivity.code === 3) {
        return true; 
      } else {
        this.currentCreateActivitie.documentClassToCreateId = null;
        return false;
      }
    }
    return false; 
  }
  


  private initializeCreateActivitie(): ICreateSubRouteFunctionActivities {
    return {
        applyInLiquidation: false,
        activityId: '',
        // defaultReasonVisitId: '',
        // documentTypeToCreateId: ''
    };
  }


  
  save() {
    const dataToSend = Object.entries(this.currentCreateActivitie)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}
